export default function getData () {
  return {
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: '요금제명',
        type: 'pie',
        radius: '50%',
        data: [ ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  }
}
